/** Keep storefront navigation in this tab and open other domains in a new tab. */
function updateLink(link) {
  const href = link.getAttribute('href')?.trim();
  if (!href || link.hasAttribute('download')) return;

  let url;
  try {
    url = new URL(href, document.baseURI);
  } catch {
    return;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

  const external = url.hostname !== window.location.hostname;
  link.setAttribute('target', external ? '_blank' : '_self');
  if (external) link.relList.add('noopener');
}

/** Process only the added subtree, including a link at its root. */
function updateLinks(root) {
  if (!(root instanceof Element)) return;
  if (root.matches('a[href]')) updateLink(root);
  root.querySelectorAll('a[href]').forEach(updateLink);
}

updateLinks(document.documentElement);

new MutationObserver((records) => {
  for (const record of records) {
    if (record.type === 'attributes') {
      if (record.target instanceof Element && record.target.matches('a[href]')) {
        updateLink(record.target);
      }
    } else {
      record.addedNodes.forEach(updateLinks);
    }
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['href'],
});
